import { useState } from "react";
import Config from "../../Config";
import Sum from "./Sum";
import Export from "./Export";
import Rp1 from "./Rp1";




function RaportView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


 

      if(props.mainView.viewSelected == 'sum')
    {
        document.title ="Podsumowanie"; 
        return (
            <div className="econtent ">                                  
                 <Sum  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }


    
      if(props.mainView.viewSelected == 'export')
    {
        document.title ="Export danych"; 
        return (
            <div className="econtent ">                                  
                 <Export  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }

  
      if(props.mainView.viewSelected == 'rp1')
    {
        document.title ="Raport okresowy 1"; 
        return (
            <div className="econtent ">                                  
                 <Rp1  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }

 
    
  

        return (
        <div className="econtent ">
             RaportView - no selected menu position
        </div>
    );
}


export default RaportView ;